import { HttpErrorResponse, HttpResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { RequestCacheService } from '@zaoblako/web/core/services/request-cache.service';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map, mergeAll } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const requestExceptionsArray: string[] = ['/basis/notification/debtor-targets-from-excel'];

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public constructor(
    private authService: AuthService,
    private errorService: ErrorService,
    private requestCacheService: RequestCacheService
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // [from Alexander Sychev]:
        //   По какой-то дурацкой причине, Angular воспринимает ответ "304 Not Modified" как ошибку,
        //   приходится доставать ответ из кэша вот таким дебильным способом.
        if (err.status === 304) {
          return this.requestCacheService
            .getResponse(request.urlWithParams)
            .pipe(map((cached) => {
              if (cached) {
                if (environment.debugLog) {
                  console.debug(`[ErrorInterceptor] Resource "${request.urlWithParams}" found in cache`);
                }
                return of(new HttpResponse({
                  status: cached?.status,
                  statusText: cached?.statusText,
                  body: cached?.body
                }));
              } else {
                if (environment.debugLog) {
                  console.debug(`[ErrorInterceptor] Resource "${request.urlWithParams}" not found in cache`);
                }
                this.errorService.addCustomError(
                  'Ошибка кэширования',
                  `Сервер ответил, что ресурс "${request.urlWithParams}" не изменился, но найти его в кэше не удалось`
                );
                return throwError(() => err);
              }
            }))
            .pipe(mergeAll());
        }

        if (err.status === 401) {
          this.authService.logout(location.pathname + location.search);
        }

        if (err.status === 0 && !navigator.onLine) {
          this.errorService.addCustomError(
            'Ошибка соединения',
            'Не удалось установить связь с сервером. Проверьте Ваше интернет соединение'
          );
        } else {
          console.log(err);

          if (!requestExceptionsArray.some((url) => err.url?.endsWith(url))) {
            this.errorService.addDefaultError(err);
          }
        }

        return throwError(() => err);
      })
    );
  }
}
